import { defineMessages } from 'react-intl';

export default defineMessages({
    yesModal: {
       id: 'twia.quoteandbind.commercial.additionalInsured.Yes',
       defaultMessage: 'Yes'
    },
    noModal: {
       id: 'twia.quoteandbind.commercial.additionalInsured.No',
       defaultMessage: 'No'
    },
    saveFailedMsg: {
        id: 'twia.quoteandbind.commercial.additionalInsured.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.quoteandbind.commercial.additionalInsured.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
       id: 'twia.quoteandbind.commercial.additionalInsured.Cancel',
       defaultMessage: 'Cancel'
    },
    removeAdditionalInsured: {
       id: 'twia.quoteandbind.commercial.additionalInsured.Remove Additional Interest',
       defaultMessage: 'Remove Additional Named Insured'
    },
    removeAddlInsuredMessage: {
       id: 'twia.quoteandbind.commercial.additionalInsured.Are you sure you want to remove this contact?',
       defaultMessage: 'Are you sure you want to remove this contact?'
    },

});
